import { useKeycloak } from "@/app/hook/use-keycloak";
import { useLoader } from "@/app/hook/use-loader";
import { useLocalization } from "@/app/hook/use-localization";
import { useEffect } from "react";
import { useLocation, useRouteError } from "react-router-dom";

export function usePageErrorBoundaryHook() {
  const error: unknown = useRouteError();
  const localization = useLocalization();
  const { setLoader } = useLoader();
  const keycloak = useKeycloak();
  const { pathname } = useLocation();

  useEffect(() => {
    setLoader(false);
  }, []);

  return {
    error,
    keycloak,
    pathname,
    localization,
  };
}
